import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
const DataContext = createContext({});

export const DataProvider = ({ children }) => {
  const navigator = useNavigate();

  const validatePincode = (value) => {
    if (/^(\d)\1{5}$/.test(value)) {
      return "Pincode cannot be a sequence of six identical digits";
    }
    return true;
  };
  const validatePassword = (value) => {
    const trimmedValue = value.trim();
    // Check if the trimmed value is empty
    if (trimmedValue.length === 0) {
      return "Empty Space Not Allow";
    }
    if (trimmedValue.length > 15) {
      return "Password cannot exceed 15 characters";
    }
    const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!regex.test(value)) {
      return "Password must be at least 8 characters long, contain at least one uppercase letter, one number, and one special character,Empty Space Not Allow";
    }
  };
  //No white space pattern
  const isWhitespace = (value) => {
    return /^\s*$/.test(value);
  };
  const validateEmail = (value) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const isValid = emailRegex.test(value);
    return isValid || "Invalid email address";
  };
  const validatePhoneNumber = (value) => {
    // const isValid = value.length === 10;
    if (value.length !== 10) {
      return "Phone number must be 10 digits";
    }
    const matches = value.match(
      /^(?:0\.(?:0[0-9]|[0-9]\d?)|[0-9]\d*(?:\.\d{1,2})?)(?:e[+-]?\d+)?$/
    );
    if (matches === null) {
      return "Only numbers allowed";
    }
  };
  const validateNumberonly = (e) => {
    const validKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"];
    if (!/[0-9]/.test(e.key) && !validKeys.includes(e.key)) {
      e.preventDefault();
    }
  };
  const validatediscountonly = (e) => {
    const validKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"];

    // Prevent non-numeric and invalid keys
    if (
      !/[0-9]/.test(e.key) && // Allow numbers
      e.key !== "." && // Allow decimal point
      !validKeys.includes(e.key) // Allow control keys
    ) {
      e.preventDefault();
    }
    // Prevent multiple decimals
    if (e.key === "." && e.target.value.includes(".")) {
      e.preventDefault();
    }
  };
  const validatedecimalNumber = (value) => {
    return value
      .replace(/^(\.)|^0(?!\.)|[^0-9.]/g, "") // Prevent invalid leading dots, 0s, or non-numeric characters
      .replace(/(\..*)\./g, "$1") // Prevent multiple dots
      .replace(/^(\d{8})\d*$/, "$1") // Restrict digits before the decimal to 8
      .replace(/^(\d*\.\d{2})\d*$/, "$1"); // Restrict to 2 decimal places
  };
  const validateEmptySpace = (e) => {
    const validKeys = ["Backspace"];
    if (!validKeys.includes(e.key)) {
      e.preventDefault();
    }
  };
  const validateAadharNumber = (value) => {
    if (value.length) {
      if (value.length !== 12) {
        return "Aadhar number must be 12 digits";
      }
    }
  };
  const validatePANNumber = (value) => {
    const panRegex = /^[A-Z,a-z]{5}[0-9]{4}[A-Z,a-z]$/;
    const isValid = panRegex.test(value);
    return isValid || "Please enter a valid PAN";
  };
  const isValidPercentage = (value) => {
    const num = Number(value);
    return num >= 0.01 && num <= 100;
  };
  const checkAlphanumeric = (e) => {
    if (!/[0-9A-Za-z]/.test(e.key)) {
      e.preventDefault();
    }
  };
  const checkAlpha = (e) => {
    if (!/[A-Za-z\s.]/.test(e.key)) {
      e.preventDefault();
    }
  };
  const checkAlphanumericDpiit = (e) => {
    if (!/[0-9A-Z]/.test(e.key)) {
      e.preventDefault();
    }
  };
  const checkUppernumeric = (e) => {
    if (!/[0-9A-Za-z]/.test(e.key)) {
      e.preventDefault();
      return;
    }
  };
  const validateCinOrPanNo = (value) => {
    if (value.length !== 21) {
      return "Input must be exactly 21 characters long.";
    }
    return true;
  };
  const CurrentDate = () => {
    var today = new Date();
    var month = today.getMonth() + 1;
    var date = today.getDate();
    if (month < 9) {
      month = 0 + month;
    }
    if (date < 9) {
      date = 0 + date;
    }
    return today.getFullYear() + "-" + month + "-" + date;
  };
  const tableIndexValue = (listSize, pageNumber, index) => {
    return listSize * pageNumber + index + 1;
  };
  const getStatus = (value) => {
    let data;
    if (value === 0) {
      data = {
        statusName: "Pending",
        color: "blue",
      };
    } else {
      data = {
        statusName: "Provisional Approved",
        color: "green",
      };
    }
    return data;
  };
  const sessionTimeout = 30 * 60 * 1000; // 30 minutes
  const warningTime = 5 * 60 * 1000; // 5 minutes before timeout
  // const sessionTimeout = 1 * 60 * 1000; // 1 minute
  // const warningTime = 10 * 1000; // 10 seconds before timeout
  var token = sessionStorage.getItem("jwttoken");
  var session = sessionStorage.getItem("session");
  const checkSessionTimout = () => {
    if (token && session === null) {
      sessionStorage.setItem("session", true);
      const timeoutId = setTimeout(() => {
        // setShowPopup(true);
      }, sessionTimeout - warningTime);
      console.log(timeoutId);

      return () => clearTimeout(timeoutId); // Cleanup on component unmount
    }
  };

  const { t, i18n } = useTranslation();
  let uselang = sessionStorage.getItem("lang");
  const [useLang, setUseLang] = useState(false);
  function changeLanguage(value) {
    // console.log(value);
    setUseLang(!value);
    let data = value === true ? "en" : "ta";
    // console.log(data);
    i18n.changeLanguage(data);
    if (uselang == null) {
      $("html").attr("lang", "en");
      sessionStorage.setItem("lang", "en");
    } else {
      $("html").attr("lang", data);
      sessionStorage.setItem("lang", data);
    }
  }
  const checkLang = () => {
    i18n.changeLanguage(uselang);
    $("html").attr("lang", uselang);
  };
  const [pageLoading, setPageLoading] = useState(false);
  const VisuallyHiddenInput = styled("input")`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
  `;
  return (
    <>
      <DataContext.Provider
        value={{
          tableIndexValue,
          validateEmail,
          validatePhoneNumber,
          validateNumberonly,
          validatedecimalNumber,
          pageLoading,
          setPageLoading,
          CurrentDate,
          getStatus,
          navigator,
          checkAlpha,
          isValidPercentage,
          validateAadharNumber,
          validatePANNumber,
          checkAlphanumeric,
          checkAlphanumericDpiit,
          checkUppernumeric,
          validatePassword,
          isWhitespace,
          validatePincode,
          validateCinOrPanNo,
          checkSessionTimout,
          validateEmptySpace,
          validatediscountonly,
          VisuallyHiddenInput,
          // Translation
          changeLanguage,
          t,
          i18n,
          checkLang,
          useLang,
        }}
      >
        {children}
      </DataContext.Provider>
    </>
  );
};
export default DataContext;
